import { useRouter } from "vue-router";
import C from "@/utils/constants.js";
import store from "@/store/";

export default function useAuthMixin() {
  const $router = useRouter();
  // const store = useStore();
  // data() {},
  // computed: {
  //   ...mapGetters("user", [
  //     "me",
  //     "roles",
  //     "isAdmin",
  //     "isBrokerAdmin",
  //     "myAgentsCount",
  //   ]),

  const reAuth = () => {
    store.dispatch("auth/reAuth");
  };

  const errorCheck = (e) => {
    console.log("!!!!!!!!! Error Check !!!!!!!!!!!!!!!");
    console.log(e);
    console.log(e.response);
    console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
    if (e.response && e.response.status) {
      console.log(e.response.status);
      if (e.response.status === 401) {
        console.log("** TODO: router issue");
        console.log("router: ", $router);
        $router.push("/login");
        // this.$router.push("/login");
      }
    }
  };

  const canView = (allowedRoles) => {
    console.log("-----------canView");
    console.log(store.state.user.me.roles);
    console.log("-----------canView");
    return (
      store.state.user.me.roles.filter(
        (r) => allowedRoles.indexOf(r.name) !== -1,
      ).length > 0
    );
  };

  const isPrimeStreetRole = () => {
    console.log("-----------isPrimestreetRole");
    console.log(store.state.user.me.roles);
    console.log("-----------isPrimestreetRole");
    return (
      store.state.user.me.roles.filter(
        (r) => r.type === C.ROLE_TYPE.PRIMESTREET_ROLE,
      ).length > 0
    );
  };

  return {
    reAuth,
    errorCheck,
    canView,
    isPrimeStreetRole,
  };
}
